import React, { FC, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";

import { Box, Stack, Typography } from "@components/base";
import { Logo } from "@components/common";
import { useValidateRegistration } from "@api";

const ConfirmEmailPage: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { validateRegistrationAsync } = useValidateRegistration();

  const handleValidateRegistration = async (
    email: string,
    hash: string,
  ): Promise<void> => {
    await validateRegistrationAsync({ email, hash });
    navigate("/");
  };

  useEffect(() => {
    const email = searchParams.get("email");
    const hash = searchParams.get("hash");

    if (email && hash) {
      handleValidateRegistration(email, hash);
    } else {
      enqueueSnackbar(t("register.emailValidationError"), { variant: "error" });
      navigate("/");
    }
  }, [searchParams]);

  return (
    <Stack justifyContent="center" alignItems="center" spacing={3} height="100vh">
      <Box width={160} textAlign="center">
        <Logo type="green0meter-with-blue-text" />
      </Box>
      <Typography variant="subtitle1" textAlign="center">
        {t("register.confirmingEmail")}
      </Typography>
    </Stack>
  );
};

export default ConfirmEmailPage;
